import React from 'react';
import classNames from 'classnames';

type BadgeProps = {
  className: string;
  children: string;
};

function Badge({ className, children }: BadgeProps): JSX.Element {
  const badgeClass = classNames(
    'px-2 inline-flex text-xs leading-5 font-semibold rounded-full',
    className
  );
  return <div className={badgeClass}>{children}</div>;
}

export default React.memo(Badge);
